export default __webpack_public_path__ + "static/media/bg-game.e0be606c.jpg";